import { IState } from '../../store';

export const selectIsBookingAvailable = (state: IState): boolean => {
  return Boolean(state.offerData.profitbaseBooking);
};
